import { useMemo } from "react";
import { useBasketStore } from "../stores/Basket.store";

const getAvailableAccountIds = (accountIds: number[]) => {
  const { accounts } = useBasketStore();

  const availableIds = useMemo(
    () =>
      accountIds.filter(
        (accountId) =>
          !accounts.some((account) => account.accountId === accountId),
      ),
    [accountIds, accounts],
  );

  const unavailableIds = useMemo(
    () => accounts.map((account) => account.accountId),
    [accounts],
  );

  const isOutOfStock = useMemo(
    () => accountIds.length === 0 || availableIds.length === 0,
    [accountIds, availableIds],
  );

  const isBuyable = useMemo(() => availableIds.length > 0, [availableIds]);

  return {
    // if there are no account in the app stock
    isOutOfStock,

    // if there are accounts in the app stock and at least one is not in the basket
    // for better code readability
    isBuyable,

    // return the available account ids not in the basket
    availableIds,

    // return the account ids ALREADY in the basket
    unavailableIds,

    // return one of the available account ids not in the basket
    getFirstAvailableId: () => availableIds[0] ?? undefined,
  };
};

export default getAvailableAccountIds;
